import { useState } from 'react';
import { useSetAtom } from 'jotai';
import { IPost } from '_interfaces/post.interface';
import { deleteDraftPostAtom } from 'atoms';
import ConfirmModal from 'components/confirm-modal';
import useToast from 'hooks/useToast';

interface IDraftDeletionConfirmDialog {
  draft: IPost;
  onClose: () => void;
}

export const DraftDeletionConfirmDialog = ({ draft, onClose }: IDraftDeletionConfirmDialog) => {
  const [isLoading, setIsLoading] = useState(false);
  const deleteDraft = useSetAtom(deleteDraftPostAtom);
  const showToast = useToast();

  const onDelete = async (post: IPost) => {
    setIsLoading(true);
    try {
      await deleteDraft({ postId: post.id, parentPath: post.parentPath });
      onClose();
    } catch {
      showToast({ type: 'error', message: 'Failed to delete draft. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ConfirmModal
      open
      isLoading={isLoading}
      title=""
      text="Are you sure you would like to discard this post?"
      confirmText="Confirm"
      onConfirm={() => onDelete(draft)}
      onClose={isLoading ? () => {} : onClose}
    />
  );
};
